import { useEffect, useState } from 'react'

export const useDebouncedValue = <T>(value: T, delay = 1000) => {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)

    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}
